import React from "react";
import Container from "../common/Container";
import { services } from "../../data/siteData";
import "../../styles/Services.css";

export default function Services() {
  return (
    <section id="services" className="services-section">
      {/* Decorative Floating Element */}
      <div className="floating-shape-1"></div>
      <div className="floating-shape-2"></div>

      <Container>
        <div className="services-header">
          <span className="service-badge">Our Services</span>
          <h2 className="service-main-title">We Provide Best Service</h2>
        </div>

        <div className="services-grid">
          {services.map((s, index) => {
            const Icon = s.icon;
            return (
              <div 
                key={s.title} 
                className="service-card-item" 
                style={{ "--delay": `${index * 0.1}s` }}
              >
                <div className="service-img-box">
                  <img 
                    src={s.image || "https://via.placeholder.com/400x300"} 
                    alt={s.title} 
                  />
                  {/* Overlapping Icon Circle */}
                  <div className="service-icon-wrapper">
                    <div className="icon-inner">
                      <Icon size={24} />
                    </div>
                  </div>
                </div>
                
                <div className="service-content-box">
                  <h3>{s.title}</h3>
                  <p>{s.desc || "We provide janitorial and this specialized is services."}</p>
                </div>
              </div>
            );
          })}
        </div>
      </Container>
    </section>
  );
}